import * as SwitchPrimitive from '@radix-ui/react-switch';
import clsx from 'clsx';

function Switch({
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={clsx(
        'data-[state=checked]:bg-fx-primary data-[state=unchecked]:bg-fx-neutral-300 peer inline-flex h-4 w-8 shrink-0 cursor-pointer items-center rounded-full border border-transparent shadow transition-all outline-none focus-visible:ring disabled:cursor-not-allowed disabled:opacity-50',
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={clsx(
          'pointer-events-none block h-3 w-3 rounded-full bg-white ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%+5px)] data-[state=unchecked]:translate-x-0',
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
